require.register("documenteditor/helpers/menu", function(exports, require, module){
  $0
  
});

